import { a as __assign, _ as __rest } from '../../tslib.es6-ff7ae7b8.js';
import { R as ResizeObserver } from '../../ResizeObserver-67118f52.js';
import { c as classNames } from '../../index-b0444989.js';
import * as React from 'react';
import React__default, { useEffect } from 'react';
import { useTransition, animated } from 'react-spring';
import { h as FocusTrap } from '../../index-3c9389ad.js';
import { S as StackingContextProvider } from '../../useOrchard-4d335da4.js';
import { u as useContentScrolls } from '../../useContentScrolls-bc13dc00.js';
import { B as Button } from '../../index-3375f7fb.js';
import { C as CloseIcon } from '../../CloseIcon-ee1d8a9a.js';
import '../../countries-0aa398a1.js';
import { Typography } from './Typography.js';
import '../../index-908dbbe0.js';
import 'react-dom';
import './IconButton.js';
import '../../skeleton.module-58f87ef6.js';
import './TextLink.js';
import '../../CircleAlertIcon-260aea89.js';
import '../../InfoIcon-a2368fdb.js';
import '../../ThemeProvider-22ee39e3.js';
import 'react-router-dom';

var styles = {"noscroll":"Modal_noscroll_a4728ed3","modal":"Modal_modal_a4728ed3","background":"Modal_background_a4728ed3","content":"Modal_content_a4728ed3","pinned":"Modal_pinned_a4728ed3","transparent":"Modal_transparent_a4728ed3","shadow":"Modal_shadow_a4728ed3","large":"Modal_large_a4728ed3","medium":"Modal_medium_a4728ed3","small":"Modal_small_a4728ed3","header":"Modal_header_a4728ed3","heading":"Modal_heading_a4728ed3","headerButtons":"Modal_headerButtons_a4728ed3","overline":"Modal_overline_a4728ed3","subtitle":"Modal_subtitle_a4728ed3","buttons":"Modal_buttons_a4728ed3","body":"Modal_body_a4728ed3","hasScroll":"Modal_hasScroll_a4728ed3","scroll":"Modal_scroll_a4728ed3","section":"Modal_section_a4728ed3","card":"Modal_card_a4728ed3","light":"Modal_light_a4728ed3","dark":"Modal_dark_a4728ed3","footer":"Modal_footer_a4728ed3","leftContainer":"Modal_leftContainer_a4728ed3","fill":"Modal_fill_a4728ed3","titleWrapper":"Modal_titleWrapper_a4728ed3","title":"Modal_title_a4728ed3"};

var Body = function (_a) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? "light" : _c, children = _a.children;
    var _d = useContentScrolls(), contentRef = _d.contentRef, contentScrolls = _d.contentScrolls;
    return (React__default.createElement("div", { className: classNames(styles.body, styles[variant], (_b = {},
            _b[styles.hasScroll] = contentScrolls,
            _b)) },
        React__default.createElement("div", { ref: contentRef, className: styles.scroll }, children)));
};

var Footer = function (_a) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? "light" : _c, buttons = _a.buttons, leftContent = _a.leftContent;
    return (React__default.createElement("footer", { className: classNames(styles.footer, (_b = {}, _b[styles[variant]] = variant, _b)) },
        React__default.createElement("div", { className: styles.leftContainer }, leftContent),
        React__default.createElement("div", { className: styles.buttons }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (buttonProps, i) { return (React__default.createElement(Button, __assign({ key: i }, buttonProps))); }))));
};

var Header = function (_a) {
    var onClose = _a.onClose, overline = _a.overline, title = _a.title, subtitle = _a.subtitle, buttons = _a.buttons;
    return (React__default.createElement("header", { className: styles.header, "data-testid": "modal-header" },
        React__default.createElement("div", null,
            overline && typeof overline === "string" ? (React__default.createElement(Typography, { variant: "body_xs", className: styles.overline, as: "div", "data-testid": "modal-overline" }, overline)) : (React__default.createElement(React__default.Fragment, null, overline)),
            title && typeof title === "string" ? (React__default.createElement(Typography, { variant: "heading_xl", className: styles.heading, as: "h1", "data-testid": "modal-title" }, title)) : (React__default.createElement(React__default.Fragment, null, title)),
            subtitle && typeof subtitle === "string" ? (React__default.createElement(Typography, { variant: "body_md", className: styles.subtitle, as: "h2", "data-testid": "modal-subtitle" }, subtitle)) : (React__default.createElement(React__default.Fragment, null, subtitle))),
        React__default.createElement("div", { className: styles.headerButtons }, buttons === null || buttons === void 0 ? void 0 :
            buttons.map(function (button, i) {
                return button instanceof Function ? (button()) : (React__default.createElement(Button, __assign({ key: i, variant: "secondary", color: "interface", size: "small" }, button)));
            }),
            onClose && (React__default.createElement(Button, { size: "small", label: "Close", variant: "secondary", color: "interface", onClick: onClose },
                React__default.createElement(CloseIcon, null))))));
};

var Section = function (_a) {
    var _b;
    var variant = _a.variant, title = _a.title, subtitle = _a.subtitle, children = _a.children;
    return (React__default.createElement("div", { "data-testid": "modal-section", className: classNames(styles.section, (_b = {},
            _b[styles[variant]] = variant,
            _b)) },
        React__default.createElement("div", { className: styles.titleWrapper },
            title && typeof title === "string" ? (React__default.createElement(Typography, { variant: "heading_md", className: styles.title, as: "h3", "data-testid": "modal-section-title" }, title)) : (React__default.createElement(React__default.Fragment, null, title)),
            subtitle && typeof subtitle === "string" ? (React__default.createElement(Typography, { variant: "body_md", className: styles.subtitle, as: "h4", "data-testid": "modal-section-subtitle" }, subtitle)) : (React__default.createElement(React__default.Fragment, null, subtitle))),
        children));
};

var noScrollClassName = "orc-modal--noscroll";
function measureScrollBarWidth(entries, isOpen) {
    var result;
    // Skip scroll bar width measurement if modal is open
    if (isOpen)
        return;
    // Measure scroll bar width
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var entry = entries_1[_i];
        var measuredWidth = self.innerWidth - entry.borderBoxSize[0].inlineSize;
        var cs = window.getComputedStyle(entry.target);
        var paddingRight = parseInt(cs.paddingRight, 10);
        result = measuredWidth;
        if (!isNaN(paddingRight)) {
            result += paddingRight;
        }
    }
    return result;
}
function Modal(_a) {
    var className = _a.className, children = _a.children, isHideBackgroundOverlay = _a.isHideBackgroundOverlay, isPinned = _a.isPinned, onClose = _a.onClose, _b = _a.focusTrapOptions, focusTrapOptions = _b === void 0 ? {} : _b, size = _a.size, otherProps = __rest(_a, ["className", "children", "isHideBackgroundOverlay", "isPinned", "onClose", "focusTrapOptions", "size"]);
    var _c = React.useState(0), scrollBarWidth = _c[0], setScrollBarWidth = _c[1];
    var _d = React.useState(false), portalActive = _d[0], setPortalActive = _d[1];
    var child = children ? React.Children.only(children) : null;
    var isOpen = Boolean(child);
    useEffect(function () {
        if (isOpen) {
            setPortalActive(true);
        }
    }, [isOpen]);
    var removeBodyStyle = function () {
        document.body.classList.remove(styles.noscroll);
        document.body.classList.remove(noScrollClassName);
        document.body.style.removeProperty("padding-right");
    };
    var handleRest = React.useCallback(function () {
        !isOpen && removeBodyStyle();
        setPortalActive(isOpen);
    }, [isOpen]);
    var transition = useTransition(children, {
        key: function (item) { return item === null || item === void 0 ? void 0 : item.key; },
        from: {
            opacity: 0,
        },
        enter: {
            opacity: 1,
        },
        leave: {
            opacity: 0,
            position: "absolute",
            left: 0,
            top: 0,
            overflow: "hidden",
        },
        onRest: handleRest,
    });
    React.useEffect(function () {
        var resizeObserver = new ResizeObserver(function (entries) {
            var scrollBarWidthResult = measureScrollBarWidth(entries, isOpen);
            if (scrollBarWidthResult) {
                setScrollBarWidth(scrollBarWidthResult);
            }
        });
        resizeObserver.observe(document.body);
        return function () {
            resizeObserver.unobserve(document.body);
        };
    }, [isOpen]);
    // On unmount
    React.useEffect(function () { return function () { return removeBodyStyle(); }; }, []);
    var handleKeyDown = React.useCallback(function (e) {
        if (onClose && e.key === "Escape") {
            onClose(e);
        }
    }, [onClose]);
    React.useEffect(function () {
        if (!onClose)
            return;
        if (isOpen) {
            window.addEventListener("keydown", handleKeyDown);
        }
        else {
            window.removeEventListener("keydown", handleKeyDown);
        }
        return function () { return window.removeEventListener("keydown", handleKeyDown); };
    }, [handleKeyDown, onClose, isOpen]);
    React.useEffect(function () {
        if (isOpen) {
            document.body.classList.add(styles.noscroll);
            document.body.classList.add(noScrollClassName);
            document.body.style.paddingRight = "".concat(scrollBarWidth, "px");
        }
    }, [isOpen, scrollBarWidth]);
    var handleOutsideClick = function (event) {
        if (event.target === event.currentTarget) {
            onClose(event);
        }
    };
    return (React.createElement(StackingContextProvider, { style: { pointerEvents: isOpen ? "auto" : "none" }, className: classNames(styles.modal, className), portalActive: portalActive }, transition(function (style, item) {
        var _a;
        return item && (React.createElement(animated.div, __assign({ role: "document", className: classNames(styles.content, (_a = {},
                _a[styles.transparent] = isHideBackgroundOverlay,
                _a[styles.pinned] = isPinned,
                _a[styles.small] = isPinned,
                _a)), style: style, onMouseDown: handleOutsideClick, onTouchStart: handleOutsideClick }, otherProps),
            React.createElement(StackingContextProvider, { noPortal: true },
                React.createElement(FocusTrap, __assign({}, focusTrapOptions),
                    React.createElement("div", { className: classNames(size && styles.shadow, size && styles[size]) }, item)))));
    })));
}
Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;
Modal.Section = Section;

export { Modal };
